






























































import Vue from "vue";
import _ from "lodash";
import { ContentItem } from "@infoland/iprova-api";
import storeHelper from "../../store/store-helper";
import Utils, { debounce } from "@/utils";
import { Category } from "@/store/modules/site";

interface CategoryWithContentItems {
    categoryId: number;
    name: string;
    contentItems: ContentItem[];
}

export default Vue.extend({
    name: "FillOutContentItemsList",
    props: {
        fillOutContentItems: Array as () => ContentItem[],
        loadingInProgress: { type: Boolean, required: true },
        showIdentifierInTitle: Boolean,
        portalId: Number,
        categories: Array as () => Category[]
    },
    data: () => ({}),
    computed: {
        isSkeletonVisible(): boolean {
            return this.loadingInProgress;
        },
        currentFillOutContentItems(): Array<ContentItem> {
            return storeHelper.contentItemsStore.currentFillOutContentItems;
        },
        fillOutGroupList(): CategoryWithContentItems[] {
            if (this.categories?.length > 0) {
                const fillOutWithCategory = this.fillOutContentItems.filter(f => {
                    return f.category != null;
                });

                let fillOutGroupsResults: { [category_id: number]: ContentItem[] } = {};
                fillOutGroupsResults = fillOutWithCategory.reduce((accumelator, current, index, sourceArray) => {
                    const category_id = current.category?.category_id || 0;

                    //category group exists?
                    if (accumelator[category_id] === undefined) {
                        //create group
                        accumelator[category_id] = [];
                    }
                    //add to category group
                    accumelator[category_id].push(current);

                    return accumelator;
                }, fillOutGroupsResults);

                const resultArray: CategoryWithContentItems[] = [];
                [
                    ...this.categories,
                    {
                        categoryId: -1,
                        name: this.$t("portal.portals.fillOut.noCategoryName").toString()
                    },
                    {
                        categoryId: -2,
                        name: this.$t("portal.portals.fillOut.fillableForms").toString()
                    }
                ].forEach(c => {
                    if (fillOutGroupsResults[c.categoryId]) {
                        resultArray.push({
                            categoryId: c.categoryId,
                            name: c.name,
                            contentItems: fillOutGroupsResults[c.categoryId].sort((a, b) => a.title.localeCompare(b.title)) //sort by title
                        });
                    }
                });

                return resultArray;
            } else {
                return [
                    {
                        categoryId: null,
                        name: null,
                        contentItems: [...this.fillOutContentItems].sort((a, b) => a.title.localeCompare(b.title)) //sort by title
                    }
                ];
            }
        }
    },
    methods: {
        itemClicked(item: ContentItem) {
            Utils.openContentItem(item, this.$router, this.portalId);
        },
        getIconName(contentItem: ContentItem) {
            if (contentItem.content_type && contentItem.content_type.content_type_id === 1) {
                contentItem.icon.icon_material_design_name = "description";
            }

            return contentItem.icon ? contentItem.icon.icon_material_design_name : null;
        },
        handleScroll: debounce(function (this: any, e: Event): void {
            const offsetHeight: number = (e.target as HTMLElement).offsetHeight;
            const scrollHeight: number = (e.target as HTMLElement).scrollHeight;
            const scrollTop: number = (e.target as HTMLElement).scrollTop;
            if (scrollTop > (scrollHeight - offsetHeight) * 0.9) {
                this.loadFillOutContentItems();
            }
        }, 100),
        loadFillOutContentItems() {
            this.$emit("load-more-items");
        },
        isDividerVisible(length: number, index: number): boolean {
            return index + 1 < length;
        },
        showInfoButton(item: ContentItem) {
            if (item.changes || item.summary || item.has_tooltip_fields) {
                return true;
            }
            return false;
        },
        openDetails: function (item) {
            this.$emit("open-content-item-details", item);
        }
    }
});
